import React from 'react'
import {Header, Content,MainImage} from './'


const MainHomeScreen = () => {
  return (
    <div className='h-screen'>
        <Header />
        <MainImage />
        <Content />
    </div>
  )
}

export default MainHomeScreen